import { Selection } from 'components/FiltersProvider/types';
import { DEFAULT_INITIAL_ADULTS, DEFAULT_INITIAL_CHILDREN } from 'components/NumberOfGuests/constants';
import { NumberOfGuestsSelection } from 'components/NumberOfGuests/types';

const CRUISE_SEARCH_REFERRAL_PARAM = '?hp_search_widget=';

const getSearchLink = (selection: Selection, numberOfGuestsSelection?: NumberOfGuestsSelection, referralPage?: string, path: string = '') => {
	const search: string[] = [];

	Object.keys(selection).forEach((filter) => {
		if (selection[filter].length) {
			search.push(`${filter}:${selection[filter].join(',')}`);
		}
	});

	if (numberOfGuestsSelection) {
		const { adults, children } = numberOfGuestsSelection;
		const isDefaultOccupancy = adults === DEFAULT_INITIAL_ADULTS && children === DEFAULT_INITIAL_CHILDREN;

		if (!isDefaultOccupancy) {
			if (adults) {
				search.push(`adults:${adults}`);
			}

			if (children) {
				search.push(`children:${children}`);
			}
		}
	}

	const currentUrl = new URLSearchParams(window.location.search);
	const params = search.join('|');

	if (params.length) {
		currentUrl.set('search', params);
	}

	let newUrl = currentUrl.toString();
	const newUrlSeparator = referralPage ? '&' : '?';
	newUrl = newUrl.length ? `${newUrlSeparator}${newUrl}` : '';

	return {
		url: `${path}/cruises${referralPage ? `${CRUISE_SEARCH_REFERRAL_PARAM}${referralPage}` : ''}${newUrl}`.replaceAll('//', '/'),
		params,
	};
};

export { getSearchLink };
